<div class="license-panel-item">
  <div class="license-panel-item__top">
    <div *ngIf="item?.licenseName?.value" class="license-panel-item__name" #nameEl>{{ item.licenseName.value }}</div>
    <div *ngIf="item?.backgroundImage?.value?.src" class="license-panel-item__image">
      <img
        [src]="item.backgroundImage.value.src"
        [alt]="item.backgroundImage.value.alt"
        [ngStyle]="{aspectRatio: item.backgroundImage?.value?.width / item.backgroundImage?.value?.height}"
      />
    </div>
  </div>
  <div class="license-panel-item__bottom">
    <div
      class="license-panel-item__description"
      [innerHTML]="item?.description?.value | safe"
      #descriptionEl
    ></div>
    <div *ngIf="item?.pricePerMonth?.value" class="license-panel-item__price">
      <div class="license-panel-item__price-per-month">
        <strong>{{
          item.pricePerMonth.value | mask : "separator" : "."
        }}</strong>
        <div class="license-panel-item__price-currency">
          {{ "licensePanel.Item.Price.Currency" | translate }}
          <span>{{ "licensePanel.Item.Price.PerMonth" | translate }}</span>
        </div>
      </div>
      <div *ngIf="item?.pricePerYear?.value" class="license-panel-item__price-per-year">
        ({{ item.pricePerYear.value | mask : "separator" : "." }}
        {{ "licensePanel.Item.Price.PerYear" | translate }})
      </div>
    </div>
    <div
      [class.bottom-aligned]="!item?.pricePerMonth?.value"
      class="license-panel-item__action"
    >
      <a
        *ngIf="item?.link?.value"
        [href]="item.link.value.url"
        [target]="item.link.value.target || '_self'"
        class="license-panel-item__link"
        >{{ item.link.value.name }}</a
      >
    </div>
  </div>
</div>
